import { useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { CouponFormFields } from '../helpers';

const useCouponFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [CouponFormFields.CODE]: [requiredRule],
    [CouponFormFields.RATE]: [requiredRule],
    [CouponFormFields.POPUP_TITLE]: [requiredRule],
    [CouponFormFields.POPUP_DESCRIPTION]: [requiredRule],
    [CouponFormFields.TEMPLATE]: [requiredRule],
  };
};

export default useCouponFormRules;
